<div class="mfa-verification-container">
  <g99-card>
    <div class="image-container">
      <img alt="Verification Illustration" [src]="mfaThumbnail" />
    </div>
    <div class="content-container">
      <h2>Two step authentication</h2>

      <ng-container *ngIf="tempSession.challengeName === 'SMS_MFA'">
        <p
          >A verification code has been sent to your registered mobile number.
          Please enter it to continue signing in to your Growth99 account.</p
        >
      </ng-container>

      <ng-container *ngIf="tempSession.challengeName !== 'SMS_MFA'">
        <p
          >Please enter the verification code from your authenticator app to
          continue signing in to your Growth99 account.</p
        >
      </ng-container>

      <form [formGroup]="mfaForm">
        <div class="form-group">
          <label for="verificationCode" class="label"
            >Enter verification code</label
          >

          <div *ngIf="errorMessage" class="error-section mt-1">
            <lib-g99-message-box
              [message]="errorMessage"
              [messageColor]="'#d92d21'"
              [icon]="exclamationSvg"
              [iconColor]="'#d92d21'"
            />
          </div>

          <lib-input
            formControlName="code"
            [placeholder]="'Enter verification code'"
            [formControls]="f['code'] || null"
            [isInvalid]="isInvalid('code')"
            [errorMessage]="errorMessages.code"
          />

          <div class="btn-continue">
            <g99-button
              width="100%"
              variant="medium"
              color="green"
              [disabled]="!mfaForm.valid"
              [loadingText]="'Verifying...'"
              [isLoading]="isSubmitting"
              (buttonClick)="onSubmit()"
            >
              Continue
            </g99-button>
          </div>
          <g99-auth-additional-option-footer />
        </div>
      </form>
    </div>
  </g99-card>
</div>
